module.exports = __webpack_public_path__ + "img/hsbc-logo.05827765.svg";